import { Injectable } from '@angular/core';
import { TrackingDataContributor, TrackingDataFragment } from '@celerofinancas/service-utils';

/**
 * CAIXA-specific tracking data contributor.
 *
 * The business team requires that the CAIXA project sends only the user's
 * first name as an identity trait: the `$last_name` and `$email` session
 * traits must NOT reach Segment.
 *
 * Contributor fragments are spread AFTER the Core session/defaultAction
 * fields (see `TrackingService.defaultTrackingData`), so setting a trait to
 * `undefined` here overrides the Core value and the key is then dropped by
 * the JSON serialization of the HTTP request body.
 */
@Injectable()
export class CaixaTrackingContributor implements TrackingDataContributor {
  /**
   * Returns the CAIXA fragment merged into every tracking payload.
   */
  public getTrackingData(): TrackingDataFragment {
    return {
      session: {
        $last_name: undefined,
        $email: undefined,
      },
    };
  }
}
